import { Tone } from "../general/dataAtoms/shared";

/**
 * How a settlement reads by where it landed in the rational range, 0 being our
 * own expected value and 1 the opponent's: below our own is a bad deal, short
 * of the even split is unremarkable, at the even split or beyond is a good one.
 * The one classification behind the quality scatter's zones and header figures
 * and the marker of the range strip in its tooltip.
 */
export const captureTone = (capture: number): Tone =>
  capture < 0 ? "adverse" : capture < 0.5 ? "neutral" : "favourable";
